import { ColumnTitle } from './ColumnTitle';
import { COLUMNS } from '../misc/columns.constants';

interface TableHeadProps {
  showColumns: string[];
}

export function TableHead({ showColumns }: TableHeadProps) {
  return (
    <thead>
      <tr>
        {showColumns.map((column) => {
          switch (column) {
            case COLUMNS.index:
              return (
                <th key={column} data-qa={column} className="narrow">
                  #
                </th>
              );

            case COLUMNS.checkbox:
              return <th key={column} data-qa={column} className="narrow" />;

            default:
              return <ColumnTitle key={column} text={column} column={column} />;
          }
        })}
      </tr>
    </thead>
  );
}
